import { ErrorMessage, Field } from "formik"
import classNames from "classnames";
import "./FormField.styles.css";
import { InputNumber } from "primereact/inputnumber";
import { useEffect } from "react";

interface Props {
  name: string;
  label?: string | undefined;
  required?: boolean;
  values?: Array<any>;
  placeholder?: string;
  value?: any;
  setFieldValue?: any;
  errors?: any;
  onChange?: any;
}

const FormFieldCurrency = ({
  name,
  label,
  required,
  placeholder,
  value,
  setFieldValue,
  errors,
  onChange
} : Props) => {


  useEffect(() => {
      let matchers = document.getElementsByClassName('p-inputtext');
      for (let i = 0; i < matchers.length; i++) {
        // matchers[i].classList.remove("colorbox");
        let result = matchers.item(i);
        if(result != null) {
          result.classList.add("form-control");
        }
      }
  }, [value]);

  return (
    <div className="d-block w-100 form-field col-12 mt-0 p-0">
      {label && <label className="form-label mb-2 w-100" htmlFor={name} >{label} {required && <span className=" text-danger">*</span>}</label>}
      
      <div className={classNames("w-100")}>
        
              <InputNumber  
                placeholder={placeholder} 
                name={name} 
                id={name} 
                value={value} 
                style={{ width: "100%" }}
                //className={"form-control"} 
                onValueChange={(e) =>{ if(e.value) setFieldValue(name, e.value) }}    // 
                useGrouping={true} 
               // minFractionDigits={2} 
               // maxFractionDigits={5}
                mode="currency"
                currency="XAF"
                locale="fr-FR"
              />
        
        <div className="span field-error"> 
          <ErrorMessage name={name}/>
        </div>
      </div>
    </div>
  )
}

export default FormFieldCurrency;